import useURLParams from 'hooks/useURLParams'
import { Key } from 'react'

interface UseAnalyticsTabsOptions {
  defaultTab?: string
}

export const useAnalyticsTabs = ({ defaultTab }: UseAnalyticsTabsOptions = { defaultTab: 'overview' }) => {
  const [searchParams, setSearchParams] = useURLParams()
  const tab = searchParams.get('tab') || 'overview'

  const handleTabChange = (key: Key) => {
    setSearchParams({ tab: key as string })
  }

  if (!searchParams.get('tab')) {
    setSearchParams({ tab: defaultTab })
  }

  return {
    tab,
    handleTabChange,
  }
}
